import { gql } from '../../../apollo/__generated__';

export const VOUCHER = gql(`
  query Voucher($code: String!, $eventId: ID!) {
    voucher(code: $code, eventId: $eventId) {
      id
      code
      amount
    }
  }
`);
